import { openChannelIOChatModal } from "./channelIO";

/**
 * Chat Modal을 열기
 * - region에 맞는 적합한 챗 모달을 open
 */
export default function openChatModal() {
  openChannelIOChatModal();
}
